<fieldset>
 <legend>
  TypeLieu
 </legend>
 <fieldset>
 <legend>
  voie
 </legend>
 <app-type-voie  [uid]="getUid()" [parentForm]="parentForm" [voie]="lieuExecution.voie"></app-type-voie>
</fieldset>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="lieuExecution.ville"

[label]="'ville'"
[type]="'text'" [rule]="'minSize_1|maxSize_100'"
[name]="getUid()+'_SepAtt_ville'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="lieuExecution.cp"

[label]="'cp'"
[type]="'text'" [rule]="'pattern_3'"
[name]="getUid()+'_SepAtt_cp'">
</app-form-input>
</fieldset>
